import { render, staticRenderFns } from "./ResponseDetailPage.vue?vue&type=template&id=7fc33a31&scoped=true"
import script from "./ResponseDetailPage.vue?vue&type=script&lang=js"
export * from "./ResponseDetailPage.vue?vue&type=script&lang=js"
import style0 from "./ResponseDetailPage.vue?vue&type=style&index=0&id=7fc33a31&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc33a31",
  null
  
)

export default component.exports